<script setup lang="ts">
const props = withDefaults(defineProps<{
  w?: string
  debug?: boolean
  options?: {
    relative: boolean
    fullHeight: boolean
  }
}>(), {
  w: '',
  debug: false,
  options: () => {
    return {
      relative: true,
      fullHeight: false,
    }
  },
})

const $attrs = useAttrs()

const filteredAttrs = computed(() => {
  const myAttrs = { ...$attrs }
  delete myAttrs.class

  return myAttrs
})
</script>

<template>
  <div class="m-col">
    <Wrap
      v-bind="filteredAttrs" :class="[{
        'h-full': options.fullHeight,
        'debug': props.debug
      }, w]"
    >
      <slot />
    </Wrap>
  </div>
</template>

<style lang="scss" scoped>
.m-col {
  // First level wrap
  :deep(> .m-wrap) {
  }

  // All Wraps
  :deep(.m-wrap) {
  }

  &.debug {
    >.m-wrap {
      box-shadow: inset 0 0 0 1px green;
      :deep(.m-col) {
        box-shadow: inset 0 0 0 1px purple;
      }
    }
  }
}
</style>
